import {Socket, io} from 'socket.io-client';

import {WebConfig} from '@buncha/utils/types';
import {getConfig} from 'src/utils/appInfo';

class SocketManager {
  private static instance: SocketManager;

  private socket: Socket | null = null;

  auth = '';

  private retryInterval: any = null;

  private constructor() {
    this.tryInitSocket();
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden && !this.connected()) this.connect();
    });
  }

  private tryInitSocket() {
    const savedParams = sessionStorage.getItem('authParams');
    const authParams = savedParams ? JSON.parse(savedParams) : {contactId: ''};

    if (!authParams?.contactId) {
      // Retry every 2 seconds until contactId exists
      if (!this.retryInterval)
        this.retryInterval = setInterval(() => this.tryInitSocket(), 2000);

      return;
    }

    // Found contactId → initialize socket
    this.auth = authParams.contactId;

    this.socket = io(getConfig(WebConfig.b2BMeijerSocketURL), {
      autoConnect: false,
      auth: {contactId: this.auth},
      transports: ['websocket'],
      reconnection: true,
      reconnectionAttempts: Infinity,
      reconnectionDelay: 800,
      closeOnBeforeunload: false,
    });

    // Clear polling
    if (this.retryInterval) clearInterval(this.retryInterval);

    this.connect();
  }

  // FOR TESTING
  // this.socket.on('connect', () => {
  //   console.log('Socket connected:', this.socket.id);
  // });

  // this.socket.on('disconnect', reason => {
  //   console.log('Socket disconnected:', reason);
  // });

  // this.socket.on('connect_error', error => {
  //   console.log('Socket connection error:', error);
  // });

  // this.socket.io.on('reconnect_attempt', () => {
  //   console.log('Socket Reconnection attempt...');
  // });

  // this.socket.io.on('reconnect', () => {
  //   console.log('Socket Successfully reconnected!');
  // });

  static getInstance(): SocketManager {
    if (!SocketManager.instance) SocketManager.instance = new SocketManager();
    return SocketManager.instance;
  }

  connected(): boolean {
    return this.socket?.connected ?? false;
  }

  connect(): void {
    if (this.socket && !this.connected()) this.socket.connect();
  }

  disconnect(): void {
    if (this.socket && this.connected()) this.socket.disconnect();
  }

  emit(event: string, data: any): void {
    if (this.socket) this.socket.emit(event, data);
  }

  on(event: string, callback: (...args: any[]) => void): void {
    if (this.socket) this.socket.on(event, callback);
  }

  off(event: string, callback: (...args: any[]) => void): void {
    if (this.socket) this.socket.off(event, callback);
  }
}

export default SocketManager;
